import type { NavigationGuard } from 'vue-router';
import { useAuthStore } from '@/stores/auth';
import { TENANT } from '@/utils/helpers';

/**
 * This guard redirects the user to the universal login page when the path is '/' and when no tenant is specified
 * and the user is not already logged in.
 * Eg. http://localhost:8080 will be redirected to http://localhost:8080/login
 */
export const handleUniversalLoginRedirection: NavigationGuard = async (to, from, next) => {
  if (!TENANT) {
    const authStore = useAuthStore();
    if (authStore.loggedIn) {
      return next();
    }
    return next({ name: 'universal-login' });
  }

  return next();
};
